import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const config = {
	instanceUrl: 'https://backend01.allbytes.net',
	userUrl: '/api/v2/user/session',
	updateUserUrl: '/api/v2/user/profile',
	registerUrl: '/api/v2/user/register',
	resetPasswordUrl: '/api/v2/user/password',
	updateSystemUrl: '/api/v2/system/',
	tableUrl: '/api/v2/mysql/_table/',
	emailUrl: '/api/v2/mailer',
	fileUrl: '/api/v2/files/',
	headers: {
		'Content-Type': 'application/json; charset=utf-8',
		'Cache-Control': 'no-cache',
		'X-DreamFactory-API-Key': '1c84b2b4531fb75650c6ffb8bf28458b4193e365fe8a9c3fb0d1c16b22fcae05',
		//'X-DreamFactory-Session-Token' : null
	}
}

@Injectable()
export class UserService {

	constructor(private http: HttpClient) { }

	// Error handlers
	private handleError(statusCode: number): string {
		let errorMessage = "";
		switch (statusCode) {
			case 401:
				errorMessage = "Email oder Passwort ist falsch";
				break;
			case 0:
				errorMessage = "Keine Verbindung zu Server möglich!";
				break;
			case 500:
				errorMessage = "Ein Fehler mit dem Server ist aufgetreten"
			default:
				errorMessage = "Ein Fehler ist aufgetreten";
		}
		return (errorMessage);
	}

	private handleResetError(statusCode: number): string {
		let errorMessage = "";
		switch (statusCode) {
			case 400:
				errorMessage = "Bitte tragen Sie eine Email-Adresse ein";
				break;
			case 404:
				errorMessage = "Diese Email konnte nicht gefunden werden";
				break;
			case 0:
				errorMessage = "Keine Verbindung zu Server möglich!";
				break;
			case 500:
				errorMessage = "Ein Fehler mit dem Server ist aufgetreten"
			default:
				errorMessage = "Ein Fehler ist aufgetreten";
		}
		return (errorMessage);
	}

	private handleGiftcodeError(statusCode: number): string {
		let errorMessage = "";
		switch (statusCode) {
			case 400:
				errorMessage = "Bitte tragen Sie einen Gutscheincode ein";
				break;
			case 404:
				errorMessage = "Dieser Gutscheincode konnte nicht gefunden werden";
				break;
			case 0:
				errorMessage = "Keine Verbindung zu Server möglich!";
				break;
			case 500:
				errorMessage = "Ein Fehler mit dem Server ist aufgetreten"
			default:
				errorMessage = "Ein Fehler ist aufgetreten";
		}
		return (errorMessage);
	}

	private handlePwChangeError(statusCode: number): string{
		let errorMessage = "";
		switch(statusCode){
			case 400:
				errorMessage = "Bitte tragen beheben Sie die oben Fehler";
				break;				
			case 0:
				errorMessage = "Keine Verbindung zu Server möglich!";
				break;
			case 500:
				errorMessage = "Ein Fehler mit dem Server ist aufgetreten"
		default: 
			errorMessage = "Ein Fehler ist aufgetreten";
		}
		return(errorMessage);			
	}

	private handleDiscountcodeError(statusCode: number): string{
		let errorMessage = "";
		switch(statusCode){
			case 400:
				errorMessage = "Bitte tragen Sie einen Rabattcode ein";
				break;				
			case 404:
				errorMessage = "Dieser Rabattcode konnte nicht gefunden werden";
				break;
			case 0:
				errorMessage = "Keine Verbindung zu Server möglich!";
				break;
			case 500:
				errorMessage = "Ein Fehler mit dem Server ist aufgetreten"
		default: 
			errorMessage = "Ein Fehler ist aufgetreten";
		}
		return(errorMessage);	
	}

	// USER API
	register(firstname: string, lastname: string, email: string, password: string): Promise<any> {
		config.headers['X-DreamFactory-Session-Token'] = '';

		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.registerUrl,
				{
					first_name: firstname,
					last_name: lastname,
					email: email,
					password: password
				}, {
				headers: new HttpHeaders(config.headers)
			}
			).subscribe((data) => {
				resolve({ email: email, password: password })
			}, (error) => {
				reject(this.handleError(error.status));
			})
		})
	}

	login(email: string, password: string): Promise<any> {
		config.headers['X-DreamFactory-Session-Token'] = '';

		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.userUrl,
				{
					email: email,
					password: password
				},
				{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((data) => {
				resolve(data)
			}, (error) => {
				reject(this.handleError(error.status));
			})
		})
	}

	logout(token) {
		config.headers['X-DreamFactory-Session-Token'] = token;

		return new Promise((resolve, reject) => {
			return this.http.delete(
				config.instanceUrl + config.userUrl,
				{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((res) => {
				config.headers['X-DreamFactory-Session-Token'] = '';
				resolve();
			}, (err) => {
				reject(err);
			})
		})

	}

	getSessionInfo(sessionToken) {
		config.headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.get(
				config.instanceUrl + config.userUrl,
				{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((data) => {
				resolve(data)
			}, (error) => {
				reject(error)
			})
		})
	}

	sendResetPasswordEmail(email) {
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.resetPasswordUrl + '?reset=true',
				{
					email: email
				},
				{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((data) => {
				console.log(data)
				resolve(data)
			}, (error) => {
				console.log(error)
				reject(this.handleResetError(error.status));
			})
		})
	}

	resetPassword(email, password, code) {
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.resetPasswordUrl,
				{
					email: email,
					code: code,
					new_password: password
				},
				{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((data) => {
				console.log(data)
				resolve(data)
			}, (error) => {
				reject(this.handleResetError(error.status));
			})
		})
	}

	updatePassword(old_password:string, new_password: string){
		return new Promise((resolve,reject)=>{
			this.http.post(
				config.instanceUrl + config.resetPasswordUrl,
				{
					old_password: old_password,
					new_password: new_password,
				},
				{
				headers: new HttpHeaders(config.headers)
				}
			).subscribe((data)=>{
				console.log(data)
				resolve(data)
			},(error)=>{
				reject(this.handlePwChangeError(error.status));
			})
		})
	}

	updateUser(firstname,lastname){
		return new Promise((resolve,reject)=>{
			this.http.post(
				config.instanceUrl + config.updateUserUrl,
				{
					first_name : firstname,
					last_name: lastname,
				},{
					headers: new HttpHeaders(config.headers)
				}
			).subscribe((data)=>{
				resolve({first_name: firstname, last_name: lastname})
			},(error)=>{
				reject(this.handleError(error.status));
			})
		})		
	}

	getRecords(table, sessionToken) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.get(
				config.instanceUrl + config.tableUrl + table,
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource);
				}
				resolve(null)
			}, (err) => {
				reject(err)
			})
		})
	}

	setRecord(table, sessionToken, userId, exerciseId) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.tableUrl + table + "?fields=*",
				{
					"resource": [
						{
							"exerciseId": exerciseId,
							"ownerId": userId
						}
					]
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Favorit gespeichert:", data)
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	deleteRecord(table, sessionToken, userId, exerciseId, databaseId) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.delete(
				config.instanceUrl + config.tableUrl + table + "/" + databaseId,
				{ headers: new HttpHeaders(headers) }
			).subscribe((data) => {
				resolve(data);
			}, (err) => {
				reject(err)
			})
		})
	}

	setBoughtVideo(table, sessionToken, userId, purchaseId) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.tableUrl + table + "?fields=*",
				{
					"resource": [
						{
							"purchaseId": purchaseId,
							"ownerId": userId
						}
					]
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Video gekauft:", data)
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	setBoughtVideos(table: string, sessionToken: string, userId: string, exercises) {
		let headers = config.headers;
		let resources = [];
		exercises.forEach((exercise) => {
			resources.push(
				{
					"purchaseId": exercise.purchaseId,
					"ownerId": userId
				}
			)
		})

		headers['X-DreamFactory-Session-Token'] = sessionToken;
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.tableUrl + table + "?fields=*",
				{
					"resource": resources
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Video gekauft:", data)
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	setPurchaseHistoryEntry(sessionToken: string, userId: string, purchaseId: string, platform: string, isBundle: boolean) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;

		let parameters: any = {
			"resource": [
				{
					"creation_date": {
						"expression": "NOW()"
					},
					"ownerid": userId,
					"status": "pending",
					"platform": platform,
				}
			]
		}

		if (!isBundle) {
			parameters.resource[0].purchaseId_exercise = purchaseId;
		} else {
			parameters.resource[0].purchaseId_bundle = purchaseId;
		}

		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.tableUrl + "purchase_history/?fields=*",
				parameters,
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Kaufvorgang gespeichert :", data)
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	updatePurchaseHistoryEntry(sessionToken: string, historyId: number, status: string, message) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;

		return new Promise((resolve, reject) => {
			this.http.patch(
				config.instanceUrl + config.tableUrl + "purchase_history/?fields=*",
				{
					"resource": [
						{
							"id": historyId,
							"status": status,
							"message": message
						}
					]
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Kaufvorgang gespeichert :", data)
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	getGiftcode(giftcode: string) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = '';

		return new Promise((resolve, reject) => {
			this.http.get(
				config.instanceUrl + config.tableUrl + "giftcodes/" + giftcode,
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (error) => {
				let errorObj = {
					origin: "giftcode",
					error: this.handleGiftcodeError(error.status)
				}
				reject(errorObj);
				//reject(err);
			})
		})
	}

	updateGiftcode(sessionToken: string, giftcode: string, is_used: boolean) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;

		return new Promise((resolve, reject) => {
			this.http.patch(
				config.instanceUrl + config.tableUrl + "giftcodes/?fields=*",
				{
					"resource": [
						{
							"giftcode": giftcode,
							"is_used": is_used,
						}
					]
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Gutschein Code eingelöst");
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	setGifcodeHistory(userId: string, sessionToken: string, giftcode, enabled_packet: string) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;

		let params = {
			"resource": [
				{
					"giftcode_id": giftcode,
					"creation_date": {
						"expression": "NOW()"
					},
					"ownerid": userId,
					"enabled_packet": enabled_packet
				}
			]
		}
		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.tableUrl + "giftcode_history",
				params,
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Gutschein Code eingelöst");
				if (data.hasOwnProperty('resource')) {
					resolve(data.resource[0]);
				}
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}

	sendEmail(sessionToken: string, first_name: string, last_name: string, email: string) {
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;

		return new Promise((resolve, reject) => {
			this.http.post(
				config.instanceUrl + config.emailUrl,
				{
					"template": "user_greeting",
					"to": [
						{
							"name": first_name + " " + last_name,
							"email": email
						}
					],
					"first_name": first_name
				},
				{ headers: new HttpHeaders(headers) }
			).subscribe((data: any) => {
				console.log("Email versandt")
				resolve(data)
			}, (err) => {
				reject(err);
			})
		})
	}


	getPriceListConfig(sessionToken: string){
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		
		return new Promise((resolve,reject)=>{
			this.http.get(
				config.instanceUrl + config.fileUrl + 'price-list.json',
				{headers: new HttpHeaders(headers)}
			).subscribe((data: any)=>{
				if(data.hasOwnProperty('resource')){
					resolve(data.resource[0]);
				}
				resolve(data)
			},(error)=>{
				reject("Preise konnten nicht geladen werden")
				//reject(err);
			})
		})		
	}

	setUserInactive(sessionToken: string, userId){
		let headers = config.headers;
		headers['X-DreamFactory-Session-Token'] = sessionToken;
		
		return new Promise((resolve,reject)=>{
			this.http.patch(
				config.instanceUrl + config.updateSystemUrl + 'user/' + userId,
				{
					"is_active": false
				},
				{headers: new HttpHeaders(headers)}
			).subscribe((data: any)=>{
				if(data.hasOwnProperty('resource')){
					resolve(data.resource[0]);
				}
				resolve(data)
			},(error)=>{
				reject(this.handleDiscountcodeError(error.status))
				//reject(err);
			})
		})	
	}

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts